import React from "react";
import { useNavigate } from "react-router-dom";
import { Award, Users } from "lucide-react";

import { formatCurrency, formatInt } from "../lib/formato";

const MEDALHA = ["text-yellow-500", "text-gray-400", "text-orange-500"];

// 5 maiores clientes do período (por valor). Clicar abre Pedidos filtrado por ele.
// "Ver todos →" abre a lista completa do mesmo período (seção Clientes, achado 77).
export default function TopClientes({ clientes, onVerTodos }) {
  const navigate = useNavigate();
  if (!clientes?.length) return null;
  return (
    <div className="bg-card rounded-xl border p-6">
      <div className="flex items-center gap-2 mb-4">
        <Users className="w-5 h-5 text-primary" />
        <h2 className="text-lg font-bold cursor-pointer hover:text-primary transition-colors" onClick={onVerTodos}>Top Clientes</h2>
        <button type="button" onClick={onVerTodos} data-e2e="ver-todos-clientes"
          className="text-xs text-muted-foreground ml-auto hover:text-primary transition-colors">Ver todos →</button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b">
              <th className="text-left py-2 px-2 text-muted-foreground font-medium">#</th>
              <th className="text-left py-2 px-2 text-muted-foreground font-medium">Cliente</th>
              <th className="text-right py-2 px-2 text-muted-foreground font-medium">Pedidos</th>
              <th className="text-right py-2 px-2 text-muted-foreground font-medium">Valor Total</th>
            </tr>
          </thead>
          <tbody>
            {clientes.slice(0, 5).map((c, i) => (
              <tr key={c.id || i} className="border-b border-muted/50 hover:bg-muted/30 transition-colors cursor-pointer"
                onClick={() => navigate(`/admin/vendas/pedidos?cliente=${encodeURIComponent(c.nome)}`)}>
                <td className="py-1.5 px-2">{i < 3 ? <Award className={`w-4 h-4 ${MEDALHA[i]}`} /> : <span className="text-muted-foreground">{i + 1}</span>}</td>
                <td className="py-1.5 px-2 font-medium text-primary hover:underline">{c.nome}</td>
                <td className="py-1.5 px-2 text-right font-semibold">{formatInt(c.quantidade_pedidos)}</td>
                <td className="py-1.5 px-2 text-right font-semibold text-green-600 dark:text-green-400">{formatCurrency(c.valor_total)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
